const totalAlertsData = state => state.totalAlertsData;

export default {
  totalAlertsData
}



// WEBPACK FOOTER //
// ./src/store/modules/anomaly/getters.js